import withFilterList from '../../elements/HOC/withFilterList'
import CustomDebounceSelect from '../../elements/Select/CustomDebounceSelect'
import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import { compose } from 'recompose'
import withUrlFetch from '../../elements/Select/withUrlFetch'
import withSpinning from '../../elements/HOC/withSpinning'
import withSort from '../../elements/HOC/withSort'
import CustomSelect from '../../elements/Select/CustomSelect'
import withMapList from '../../elements/HOC/withMapList'

export default function useFetchSelectUrl(
  selectFetchOptions,
  dependencyArray = [],
  doNotFetch = false,
  initialSelect = Select,
  mapFunc = data => data,
  cleanUpFunc = () => {},
  debounce = false,
  filterFunc = () => true,
) {
  const [{ Select: FetchSelectCmp }, setBudgetSelect] = useState({
    Select: initialSelect,
  })

  useEffect(() => {
    if (!doNotFetch)
      setBudgetSelect({
        Select: compose(
          withUrlFetch(selectFetchOptions),
          withSpinning,
          withSort,
          withMapList(mapFunc),
          withFilterList(filterFunc),
        )(debounce ? CustomDebounceSelect : CustomSelect),
      })
    return cleanUpFunc
  }, dependencyArray)
  return [FetchSelectCmp]
}
